import React, { Component } from 'react'
import Button from '../button/Button'
import './designation.css'

export default class Designation extends Component {
    render() {
        return (
            <div className="designation">
                <h1 className="designation-name">MAHBUB KHAN</h1>
                <p className="designation-title">TRAVELLER , FOODIE, VLOGGER</p>
                <p className="designation-details">Hello everyone, my name is Mahbub Khan , I am a traveller, foodie and vlogger. 
                I like to travel, try new things, meet new people and enjoy my life.</p>
                <div className="buttons-group">
                    {/* <Button title="BLOG"/> */}
                    <Button title="VLOGS"/>
                    <Button title="CONTACT"/>
                </div>
                
            </div>
        )
    }
}
